export default __webpack_public_path__ + "static/media/Madison Nguyen.3b2f574c.jpg";